import getEnv from '@providers/getEnv'
export default getEnv() === 'local'
  ? '6Ld-G-YZAAAAAPN6YFfAznm-ajgjsLh7TAoJGTHv'
  : '6LdkTO4ZAAAAAHlcPrJ01VJPrHAWR8_bKd39Ru-w'
